import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { usePasStore } from './pasStore';
import { PolicyAdminNav } from './components/PolicyAdminNav';
import { Toaster } from './components/Toaster';
import { AdministrationPage } from './pages/AdministrationPage';
import { Dashboard } from './pages/Dashboard';
import { DocumentsPage } from './pages/DocumentsPage';
import { PoliciesPage } from './pages/PoliciesPage';
import { PolicyDetailPage } from './pages/PolicyDetailPage';
import { RenewalsPage } from './pages/RenewalsPage';
import { SearchPage } from './pages/SearchPage';
import { UnderwritingQueue } from './pages/UnderwritingQueue';

export const PolicyAdmin: React.FC = () => {
  const fetchPolicies = usePasStore((s) => s.fetchPolicies);
  const fetchReferenceData = usePasStore((s) => s.fetchReferenceData);

  useEffect(() => {
    fetchPolicies();
    fetchReferenceData();
  }, [fetchPolicies, fetchReferenceData]);

  return (
    <div>
      <PolicyAdminNav />
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="policies" element={<PoliciesPage />} />
        <Route path="policies/:id" element={<PolicyDetailPage />} />
        <Route path="underwriting" element={<UnderwritingQueue />} />
        <Route path="renewals" element={<RenewalsPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="administration" element={<AdministrationPage />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
      <Toaster />
    </div>
  );
};
